import React from "react";
import { FormattedMessage } from "react-intl";

interface TextButtonProps {
    id: string;
    itemId: string | number;
    onClick?: ((itemId: string | number, boolParameter?: boolean) => void) | null;
    messageKey?: string;
    text: string;
    className: string;
}
const TextButton = (props: TextButtonProps) => {
    const handleClick = (handleClickProps: TextButtonProps) => {
        if (handleClickProps.onClick) {
            handleClickProps.onClick(handleClickProps.itemId);
        }
    };
    return (
        <div
            id={props.id}
            className={`itemText ${props.className} ${props.onClick ? "itemTextClickable" : ""}`}
            onClick={() => handleClick(props)}
        >
            {props.messageKey ? <FormattedMessage id={props.messageKey} /> : props.text}
        </div>
    );
};

export default TextButton;
